export default "__VITE_ASSET__z6QLXr$I__"